export function setDownloads (state, value) {
  state.downloads = value
}
